import { showCartErrorMessage } from 'features/cart/desktop';
import { utagLinkCart, utagViewArtificialPageView } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import { GetCartContentForPrint } from '../../api';
import printCartContent from '../printCartContent';
import cleanupCartPrintContent from '../cleanupCartPrintContent';
import PrintCartLinkTemplate from '../templates/PrintCartLinkTemplate';

import PrintOptionsModal from './PrintOptionsModal';

const trackArtificialPageView = utagViewArtificialPageView();
const trackCartActions = utagLinkCart();

const PrintCartLink = CartBaseItemView.extend({
	JSXTemplate: PrintCartLinkTemplate,
	tagName: 'button',
	className: 'jsPrint anchorLink',
	attributes: {
		type: 'button',
		'aria-haspopup': 'true',
		'aria-label': 'print'
	},
	events: {
		click: 'displayPrintCartModal'
	},
	displayPrintCartModal (e) {

		e.preventDefault();

		const { isCustomerService } = window.lp.globals;
		let afterOpenEvt;
		let closeEvt;

		trackCartActions({
			eventAction: isCustomerService ? 'Click-Employee-Print' : 'Click-Print-Cart'
		});

		setGenericEvent({ event_name: isCustomerService ? 'cart_employee_print_click' : 'cart_print_click' });

		if (isCustomerService) {

			afterOpenEvt = () => new PrintOptionsModal({ el: '#lpModalContent' }).render();
			closeEvt = () => {

				$('#printOptionsContainer')
					.removeClass('hidden')
					.find('.printStyleOptions,.printCartOptions')
					.addClass('hidden');
				$('#printOutputContainer').addClass('hidden');

				cleanupCartPrintContent();

			};

		} else {

			afterOpenEvt = () => {

				const request = GetCartContentForPrint().then((response) => {

					if (response.IsSuccess) {

						$('#printOutput').html(response.GlobalCartResponseModel);
						$('.printContentBtn')
							.off('click')
							.on('click', (evt) => {

								trackCartActions({
									eventAction: 'Click-Print-Cart-Confirm'
								});

								setGenericEvent({ event_name: 'cart_print_confirm' });

								printCartContent(evt);

							});

					} else {

						showCartErrorMessage({
							response,
							fromModal: true
						});

					}

				});

				$(cart).trigger('indicateLoad', request);
				trackArtificialPageView({ pageName: 'Print' });

			};

			closeEvt = () => {

				trackArtificialPageView({ pageName: '' });

				cleanupCartPrintContent();

			};

		}

		$('body').lpModal({
			onInit: true,
			appendContentToForm: false,
			content: $('#printCartContainer'),
			height: 517,
			width: 756,
			afterOpenEvt,
			closeEvt
		});

	}
});

export default PrintCartLink;
